import { preload } from 'react-isomorphic-render';
import { connect } from 'react-redux';
import { contentfulModels } from '@glowforge/ui-common';
import { fetchUserPurchaseHistory } from 'app/api/account-settings-api';
import { manageSubscription } from 'app/api/subscriptions';
import PurchaseHistory from 'app/components/settings/purchase-history';
import { getPurchaseHistory } from 'app/selectors/user';
import { subscriptions } from 'app/selectors/subscriptions';

const { getStringsForPage } = contentfulModels;

// TODO: This page doesn't have a "loading" state. Does it need one?
const mapStateToProps = state => ({
  purchaseHistory: getPurchaseHistory(state),
  canManageSubscriptions: subscriptions.canManage(state),
  isManagePending: subscriptions.isManagePending(state),
  subscriptionManageLink: subscriptions.getManageLink(state),
  pageStrings: getStringsForPage(_.get(state, 'accountSettings.settingsPage.fields')),
});

const mapDispatchToProps = dispatch => ({
  onManageSubscriptions: (url, onComplete) => dispatch(manageSubscription(url, onComplete)),
});

const PurchaseHistoryContainer = connect(mapStateToProps, mapDispatchToProps)(preload(
  ({ dispatch, getState }) => Promise.all([
    dispatch(fetchUserPurchaseHistory()),
  ]))(PurchaseHistory),
);

export default PurchaseHistoryContainer;



// WEBPACK FOOTER //
// ./app/containers/settings/purchase-history.js